import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Typography from 'fuse-ui/components/Typography';
import { formatForNull } from '../utils/common-utils';

const styles = theme => ( {
    flexTitle: {
        minWidth: '45%',
    },
    flexTitleExpansion: {
        width: '48%',
    },
    fullWidth: {
        width: '100%',
    },
    gutterTop: {
        paddingTop: 8,
    },
    sectionPadding: {
        paddingBottom: 8,
    },
    tableFlex: {
        '&:not(:first-of-type)': {
            paddingTop: 8
        },
        display: 'flex',
        paddingBottom: 8,
    },
    value: {
        wordBreak: 'break-word',
    },
} );

const ColumnedSection = ( { classes, data, expandable, gutterTop, labelWidthPercent } ) => {
    const width = expandable ? 48 : labelWidthPercent;

    return (
        <div className={
            cx( classes.fullWidth, {
                [classes.gutterTop]: gutterTop,
                [classes.sectionPadding]: !expandable,
            } )
        }>
            {
                data.map( ( { title, automationId, value } ) => {
                    return (
                        <div
                            key={title}
                            className={classes.tableFlex}
                            data-automation-id={automationId}
                        >
                            <Typography
                                color="textSecondary"
                                style={{ minWidth: `${width}%` }}
                            >
                                {title}
                            </Typography>
                            <Typography className={classes.value}>{formatForNull( value )}</Typography>
                        </div>
                    );
                } )
            }
        </div>
    );
};

ColumnedSection.propTypes = {
    classes: PropTypes.object.isRequired,
    data: PropTypes.array.isRequired,
    expandable: PropTypes.bool.isRequired,
    gutterTop: PropTypes.bool.isRequired,
    labelWidthPercent: PropTypes.number,
    TitleProps: PropTypes.object,
};

ColumnedSection.defaultProps = {
    expandable: false,
    gutterTop: true,
    labelWidthPercent: 35,
};

export default withStyles( styles )( ColumnedSection );
